import { Construction } from "lucide-react";

/** Onglet mis en pause : l'icône reste dans le menu, le contenu annonce son retour. */
export default function TravauxNotice({ title, children, testId }) {
  return (
    <div className="h-full flex items-center justify-center p-6" data-testid={testId}>
      <div className="max-w-sm text-center space-y-3">
        <div className="mx-auto w-12 h-12 rounded-full flex items-center justify-center" style={{ background: "#FBF1DC" }}>
          <Construction className="w-6 h-6" style={{ color: "#9A6A12" }} />
        </div>
        <p className="text-sm font-bold" style={{ color: "#1A1A1A" }}>{title}</p>
        <p className="text-xs leading-relaxed" style={{ color: "#4A4A4A" }}>{children}</p>
        <p className="text-[11px]" style={{ color: "#7A7A7A" }}>Merci de votre patience, il revient très vite.</p>
      </div>
    </div>
  );
}
